export class VisitService {
  constructor($http) {
    this.http = $http;
  }

  list(page, limit) {
    return this.http.get(`/api/visit/list/${page}/${limit}`);
  }
}
